export const arrayIsEqual = (array1 : any[], array2: any[]) => {
return (array1.length == array2.length) && array1.every(function(element, index) {
    return element === array2[index]; 
});
}